// we're in a deeper folder than fields.js - assume it is loaded
PD.forms.fields.CheckboxField = (function(){
  function CheckboxField(cfg, index, form) {
    this._super.apply(this, arguments); // call generic TextField constructor
  }
  CheckboxField.prototype = {
    text: "",
    checkedValue: "1",
    uncheckedValue: "0",
    checkIcon: "check",
    bare: false,
    _template:
      '<% if (!bare) { %>' +
        '<div class="form-group">' +
          '<label for="<%=id%>" class="col-sm-3 control-label"><%=label?label+\':\':\'\'%></label>' +
          '<div class="col-sm-<%=helpText? "8" : "9"%> cm-checkbox-container">' + 
      '<% } %>' +
            '<div class="cm-checkbox" id="<%=id%>">' +
              '<span class="fa fa-<%= checkIcon %>"></span>'+
            '</div>' +
            '<%=text? "&nbsp;" + text : ""%>'+
      '<% if (!bare) { %>' +
          '</div>' +
        '<% if (helpText) { %>' +
          '<div class="col-sm-1 hidden-xs">' +
            '<i class="fa fa-question-circle-o" role="button" data-toggle="popover" title="<%=helpText.title%>" data-content="<%=helpText.content%>"></i>'+
          '</div>' +
        '<% } %>' +
        '<% if (errorText) { %>' +
          '<div class="col-sm-9 col-sm-offset-3 error-text">' +
            '<p><%=errorText%></p>' +
          '</div>' +
        '<% } %>' +
        '</div>' +
      '<% } %>'
  };
  CheckboxField.prototype._get$Element = function(){
    var self = this;
    this._super.prototype._get$Element.apply(this, arguments);
    this.$inp = $("#"+this.id,this.$elm);
    this.$inp.on("change", function(){
      if (self.onChange) {
        self.onChange(self.getValue());
      }
    });
    if (this.bare) {
      this.$inp = this.$elm;
    }

    if (this.disabled) {
      this.$inp.addClass("disabled");
    }
    if (this.initialValue !== undefined) {
      this.setValue(this.initialValue);
    }

    this.on = this.$inp.on.bind(this.$inp);
    this.off = this.$inp.off.bind(this.$inp);
    this.trigger = this.$inp.trigger.bind(this.$inp);

    return this.$elm;
  };
  CheckboxField.prototype._valueIsTrue = function(val){
    return ([true, "1", "true", "on", 1].indexOf(val) !== -1);
  };
  CheckboxField.prototype._setFeedback = function(feedback) {};
  CheckboxField.prototype.getValue = function(){
    return this.$inp.is(".checked") ? 
      this.checkedValue : this.uncheckedValue;
  };
  CheckboxField.prototype.setValue = function(val){
    this.$inp.toggleClass("checked", this._valueIsTrue(val));
    return true;
  };
  CheckboxField.prototype.clearValue = function(val){
    this.setValue(this.defaultValue);
    return true;
  };

  CheckboxField.prototype.setDisabled = function(state){
    this.$inp.toggleClass("disabled", state);
    return state;
  }

  // inherit from generic field
  PD.forms.fields.register(["checkbox", "CheckboxField"], CheckboxField);

  return CheckboxField;
})();
